module.exports = "<ul>\n<li>malert、mconfirm、mprompt支持返回Promise</li>\n</ul>\n";